<template>
  <div class="list-page-header">
    <div class="left">
      <slot name="left">
        <template v-if="filtersTemplate">
          <generic-form
            ref="form"
            :attributes="filterFormAttributes"
            :form="filters"
            :form-template="filtersTemplate"
            :border="false"
          />
          <el-button
            :disabled="disabled"
            class="search-btn mt-3"
            icon="el-icon-search"
            size="mini"
            type="primary"
            @click="handleSearch"
          >{{ $t('button.search') }}</el-button>
        </template>
      </slot>
    </div>

    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
import { createComponent, reactive } from '@vue/composition-api'

import GenericForm from '../../../components/form/Form.vue'

export default createComponent({
  name: 'ListPageHeader',
  components: {
    GenericForm,
  },
  props: {
    /*
     * Whether operation has to be disabled (may be due to loading)
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /*
     * Descriptive list of objects of each filter in the form
     * Refer template to documentation from "/src/components/form/README.md"
     */
    filtersTemplate: {
      type: Array,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const { emit, refs } = ctx

    // Filters related feature in header
    const updateFilterDefaultDict = (acc, filter) => ({ ...acc, [filter.key]: filter.default })
    const getFilters = () => (
      Array.isArray(props.filtersTemplate)
        ? props.filtersTemplate.reduce(updateFilterDefaultDict, {})
        : {}
    )
    const filters = reactive(getFilters())

    const handleSearch = () => {
      refs.form.$refs.form.validate().then(() => {
        emit('search', filters)
      }).catch(() => {
        this.$alert(this.$t('error.pleaseFillInAndCheckErrors'), this.$t('common.oops'), {
          confirmButtonText: this.$t('button.ok'),
        });
      })
    }
    const filterFormAttributes = {
      disabled: props.disabled,
      labelWidth: '0px',
    }

    return {
      filterFormAttributes,
      filters,
      handleSearch,
    }
  },
})
</script>

<style lang="scss" scoped>
.list-page-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > * {
    display: flex;
  }

  .el-form {
    flex-direction: row;
  }

  ::v-deep {
    .el-form > * {
      margin-right: 8px;
    }
    .el-form-item__label {
      width: 100% !important;
      text-align: left;
      font-weight: 500;
    }
  }
}

.search-btn {
  max-height: 28px;
}
</style>
